"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _reactIntl = require("react-intl");

var _reactResponsive = require("react-responsive");

var _Popover = require("../../../../../Popover");

var _StyledLayout = require("../../../../../StyledLayout");

var _StyledTypography = require("../../../../../StyledTypography");

var _Icon = _interopRequireDefault(require("../../../../../Icon"));

var _SocialGroup = _interopRequireDefault(require("../../../../common/components/SocialGroup"));

var _Elements = require("./Elements");

var _Elements2 = require("../../../../Elements");

var _Elements3 = require("../../../Moodie/Elements");

var _constants = require("../../../../constants/constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Topnav = function Topnav(_ref) {
  var _location$pathname, _location$pathname2, _location$pathname3, _location$pathname4, _folders$, _folders$2;

  var folders = _ref.folders,
      websiteName = _ref.websiteName,
      publicUrl = _ref.publicUrl,
      visibilityOptions = _ref.visibilityOptions,
      socialMedia = _ref.socialMedia,
      username = _ref.username,
      colour = _ref.colour;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showHamburgerMenu = _useState2[0],
      setShowHamburgerMenu = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      overflowVisibility = _useState4[0],
      setOverflowVisibility = _useState4[1];

  var isDesktopSmall = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1152px)'
  });
  var triggerRef = (0, _react.useRef)(null);
  var location = (0, _reactRouterDom.useLocation)();

  var renderFolder = function renderFolder() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, folders.map(function (folder) {
      if (folder) {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
          key: folder.id,
          to: "".concat(publicUrl, "/gallery/").concat(folder === null || folder === void 0 ? void 0 : folder.id),
          activeClassName: "navlink-selected",
          style: {
            width: '100%'
          }
        }, /*#__PURE__*/_react["default"].createElement(_Elements3.FolderBox, {
          px: "sm",
          py: "xs",
          key: folder === null || folder === void 0 ? void 0 : folder.legacyId,
          pointer: true,
          onClick: function onClick() {
            setOverflowVisibility(false);
          }
        }, /*#__PURE__*/_react["default"].createElement(_StyledTypography.Paragraph, {
          portfolioFontFamily: true,
          portfolioForeground2: true
        }, folder.name)));
      }

      return null;
    }));
  };

  var renderDesktopTopnav = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Elements2.Logo, {
    uppercase: true,
    bold: true,
    portfolioForeground1: true,
    singleLineText: true,
    hasHover: true,
    colour: _constants.PORTFOLIO_THEME_COLOR[colour]
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: publicUrl
  }, websiteName)), /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    flex: true,
    align: "center",
    style: {
      flex: '0 0 auto'
    }
  }, /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    flex: true,
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Elements.NavLinkBox, {
    fontColor: _constants.PORTFOLIO_THEME_COLOR[colour]
  }, /*#__PURE__*/_react["default"].createElement(_Elements2.PortfolioParagraph, {
    large: true,
    portfolioForeground1: true
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
    to: publicUrl,
    exact: true,
    activeClassName: "navlink-selected"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.topnav.link.home"
  })))), /*#__PURE__*/_react["default"].createElement(_Elements.NavLinkBox, {
    fontColor: _constants.PORTFOLIO_THEME_COLOR[colour]
  }, folders.length !== 1 ? /*#__PURE__*/_react["default"].createElement(_Popover.Popover, {
    id: "portfolio-moodie-popover",
    render: renderFolder(),
    triggerRef: triggerRef,
    onClickout: function onClickout() {
      return setOverflowVisibility(false);
    },
    triggerShow: function triggerShow() {
      return setOverflowVisibility(true);
    },
    popoverNestedRole: "dialog",
    alignment: "flex-end",
    position: "bottom-left",
    width: 174,
    show: overflowVisibility
  }, /*#__PURE__*/_react["default"].createElement(_Elements.StyledGalleryLinkBox, {
    flex: true,
    align: "center",
    pointer: true,
    triggerRef: triggerRef,
    onClick: function onClick() {
      setOverflowVisibility(!overflowVisibility);
    },
    fontColor: _constants.PORTFOLIO_THEME_COLOR[colour],
    isGalleryLink: location === null || location === void 0 ? void 0 : (_location$pathname = location.pathname) === null || _location$pathname === void 0 ? void 0 : _location$pathname.includes('gallery')
  }, /*#__PURE__*/_react["default"].createElement(_Elements2.PortfolioParagraph, {
    large: true,
    portfolioForeground1: !(location !== null && location !== void 0 && (_location$pathname2 = location.pathname) !== null && _location$pathname2 !== void 0 && _location$pathname2.includes('gallery')),
    fontColor: location !== null && location !== void 0 && (_location$pathname3 = location.pathname) !== null && _location$pathname3 !== void 0 && _location$pathname3.includes('gallery') ? _constants.PORTFOLIO_THEME_COLOR[colour] : false,
    bold: location === null || location === void 0 ? void 0 : (_location$pathname4 = location.pathname) === null || _location$pathname4 === void 0 ? void 0 : _location$pathname4.includes('gallery'),
    mr: "xs"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.topnav.link.galleries"
  })), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: "chevronDown",
    size: "xs"
  }))) : /*#__PURE__*/_react["default"].createElement(_Elements2.PortfolioParagraph, {
    large: true,
    portfolioForeground1: true
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
    to: "".concat(publicUrl, "/gallery/").concat(folders === null || folders === void 0 ? void 0 : (_folders$ = folders[0]) === null || _folders$ === void 0 ? void 0 : _folders$.id),
    activeClassName: "navlink-selected"
  }, folders === null || folders === void 0 ? void 0 : (_folders$2 = folders[0]) === null || _folders$2 === void 0 ? void 0 : _folders$2.name))), /*#__PURE__*/_react["default"].createElement(_Elements.NavLinkBox, {
    fontColor: _constants.PORTFOLIO_THEME_COLOR[colour]
  }, /*#__PURE__*/_react["default"].createElement(_Elements2.PortfolioParagraph, {
    large: true,
    portfolioForeground1: true
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
    to: "".concat(publicUrl, "/about"),
    activeClassName: "navlink-selected"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.topnav.link.about"
  })))), /*#__PURE__*/_react["default"].createElement(_Elements.NavLinkBox, {
    fontColor: _constants.PORTFOLIO_THEME_COLOR[colour]
  }, /*#__PURE__*/_react["default"].createElement(_Elements2.PortfolioParagraph, {
    large: true,
    portfolioForeground1: true
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
    to: "".concat(publicUrl, "/contact"),
    activeClassName: "navlink-selected"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.topnav.link.contact"
  }))))), /*#__PURE__*/_react["default"].createElement(_Elements.SocialBox, {
    flex: true,
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_SocialGroup["default"], {
    socialMedia: socialMedia,
    visibilityOptions: visibilityOptions,
    size: "xs",
    username: username,
    fontColor: colour
  }))));

  var renderMobileTop = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Elements2.Logo, {
    uppercase: true,
    portfolioForeground1: true,
    bold: true,
    singleLineText: true,
    onClick: function onClick() {
      return setShowHamburgerMenu(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: publicUrl,
    onClick: function onClick() {
      window.scrollTo(0, 0);
    }
  }, websiteName)), /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    pointer: true,
    style: {
      flex: '0 0 auto'
    }
  }, showHamburgerMenu ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: "close",
    onClick: function onClick() {
      setShowHamburgerMenu(false);
    }
  }) : /*#__PURE__*/_react["default"].createElement(_Elements2.PortfolioParagraph, {
    portfolioForeground1: true,
    underline: true,
    small: true,
    onClick: function onClick() {
      setShowHamburgerMenu(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.topnav.link.menu"
  }))), showHamburgerMenu && /*#__PURE__*/_react["default"].createElement(_Elements.MobileHamburgerMenu, {
    flex: true,
    column: true
  }, /*#__PURE__*/_react["default"].createElement(_StyledTypography.HeadingMedium, {
    bold: true,
    center: true,
    portfolioForeground1: true,
    portfolioFontFamily: true,
    mb: "md"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.topnav.link.photography"
  })), folders.map(function (folder) {
    if (folder) {
      return /*#__PURE__*/_react["default"].createElement(_Elements2.PortfolioParagraph, {
        key: folder.id,
        large: true,
        center: true,
        portfolioForeground1: true,
        mb: "md",
        as: "a"
      }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        to: "".concat(publicUrl, "/gallery/").concat(folder.id),
        onClick: function onClick() {
          setShowHamburgerMenu(false);
        }
      }, folder.name));
    }

    return null;
  }), /*#__PURE__*/_react["default"].createElement(_StyledTypography.HeadingMedium, {
    bold: true,
    center: true,
    portfolioForeground1: true,
    portfolioFontFamily: true,
    mb: "md"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "".concat(publicUrl, "/about"),
    onClick: function onClick() {
      setShowHamburgerMenu(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.topnav.link.about"
  }))), /*#__PURE__*/_react["default"].createElement(_StyledTypography.HeadingMedium, {
    bold: true,
    center: true,
    portfolioForeground1: true,
    portfolioFontFamily: true,
    mb: "md"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "".concat(publicUrl, "/contact"),
    onClick: function onClick() {
      setShowHamburgerMenu(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.topnav.link.contact"
  }))), /*#__PURE__*/_react["default"].createElement(_Elements.MobileSocialBox, {
    flex: true,
    align: "center",
    justify: "center"
  }, /*#__PURE__*/_react["default"].createElement(_SocialGroup["default"], {
    socialMedia: socialMedia,
    visibilityOptions: visibilityOptions,
    username: username,
    fontColor: colour
  }))));

  return /*#__PURE__*/_react["default"].createElement(_Elements.TopnavBox, {
    flex: true,
    align: "center",
    justify: "space-between",
    isDesktop: isDesktopSmall,
    fontColor: _constants.PORTFOLIO_THEME_COLOR[colour]
  }, isDesktopSmall ? renderDesktopTopnav : renderMobileTop);
};

Topnav.defaultProps = {
  websiteName: '',
  publicUrl: '/',
  socialMedia: {
    instagram: '',
    facebook: '',
    twitter: ''
  },
  visibilityOptions: {
    pxProfile: 'VISIBLE'
  },
  username: '',
  colour: ''
};
Topnav.propTypes = {
  folders: _propTypes["default"].arrayOf(_propTypes["default"].shape()).isRequired,
  websiteName: _propTypes["default"].string,
  publicUrl: _propTypes["default"].string,
  socialMedia: _propTypes["default"].shape({
    instagram: _propTypes["default"].string,
    facebook: _propTypes["default"].string,
    twitter: _propTypes["default"].string
  }),
  visibilityOptions: _propTypes["default"].shape({
    pxProfile: _propTypes["default"].oneOf(['VISIBLE', 'HIDDEN'])
  }),
  username: _propTypes["default"].string,
  colour: _propTypes["default"].string
};
var _default = Topnav;
exports["default"] = _default;